const yieldToMainThread = (): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, 0);
  });

export default yieldToMainThread;
